module.exports = __webpack_public_path__ + "static/media/automotive.2004fe9e.jpg";